import { render, staticRenderFns } from "./CampaignCard.vue?vue&type=template&id=212c5456&scoped=true&"
import script from "./CampaignCard.vue?vue&type=script&lang=ts&"
export * from "./CampaignCard.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignCard.vue?vue&type=style&index=0&id=212c5456&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212c5456",
  null
  
)

export default component.exports